import styled from 'styled-components';

export const Blockquote = styled.blockquote`
  position: relative;
  border-left: 4px solid ${({ theme }) => theme.palette.primaryLink};
  margin-top: ${({ theme }) => theme.spacing.medium};
  margin-bottom: ${({ theme }) => theme.spacing.medium};
  padding: ${({ theme }) =>
    `${theme.spacing.tiny} ${theme.spacing.standard} ${theme.spacing.standard}`};

  p:last-child {
    margin-bottom: 0;
  }
`;

export const BrushElement = styled.img`
  display: block;
  width: 64px;
  height: 46px;
  margin-bottom: ${({ theme }) => theme.spacing.standard};
`;
